
<template>
  <div>
    <mdb-modal
      centered
      @close="$store.commit('clearCurrentModal')"
      elegant
      size="lg"
    >
      <mdb-modal-header>
        <mdb-modal-title class="isi-heading-blue">{{
          options.title
        }}</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="d-flex flex-column pt-0">
        <h3 class="isi-sub-heading-gray mb-3">
          Desktop PCs / Laptops
          <span
            >&minus; Enough desktop pcs or laptop devices of the same type to
            run full capacity per session.</span
          >
        </h3>
        <h3 class="isi-sub-heading-gray mb-3">
          Tablet devices
          <span
            >&minus; Enough tablets or similar devices of the same type to run
            full capacity per session.</span
          >
        </h3>
        <h3 class="isi-sub-heading-gray mb-3">
          Broadband Internet
          <span
            >&minus; Facility is equipped with broadband internet of at least
            100Mbit/s with a stable WIFI connection.</span
          >
        </h3>
        <h3 class="isi-sub-heading-gray mb-3">
          Redundant Internet Connection
          <span
            >&minus; Facility is equipped with a redundant internet connection.
            In the event of an internet outage on the primary internet
            connection, the secondary internet connection will step in
            automatically to avoid a loss of internet connection.</span
          >
        </h3>
        <h3 class="isi-sub-heading-gray mb-3">
          Live Stream
          <span
            >&minus; The facility is equipped with camera, sound and software
            equipment for live streaming.</span
          >
        </h3>
        <mdb-btn
          class="btn btn-isi align-self-center"
          @click.native="$store.commit('clearCurrentModal')"
          >Ok</mdb-btn
        >
      </mdb-modal-body>
    </mdb-modal>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
</style>